import SihirDefteriLanding from "pages/LandingPages/SihirDefteri";

export default SihirDefteriLanding;
